import React, { forwardRef } from 'react';
import HeroSectionSplit from './internal/HeroSectionSplit';
import HeroSectionTextual from './internal/HeroSectionTextual';
import HeroSectionVisual from './internal/HeroSectionVisual';
export var HeroSectionVariant;
(function (HeroSectionVariant) {
    HeroSectionVariant["split"] = "split";
    HeroSectionVariant["textual"] = "textual";
    HeroSectionVariant["visual"] = "visual";
})(HeroSectionVariant || (HeroSectionVariant = {}));
export var HeroSectionSplitTheme;
(function (HeroSectionSplitTheme) {
    HeroSectionSplitTheme["light"] = "light";
    HeroSectionSplitTheme["dark"] = "dark";
    /** Listens to page theme */
    HeroSectionSplitTheme["transparent"] = "transparent";
})(HeroSectionSplitTheme || (HeroSectionSplitTheme = {}));
export var HeroSectionVisualContentPlacement;
(function (HeroSectionVisualContentPlacement) {
    HeroSectionVisualContentPlacement["overlay"] = "overlay";
    HeroSectionVisualContentPlacement["below"] = "below";
})(HeroSectionVisualContentPlacement || (HeroSectionVisualContentPlacement = {}));
export var HeroSectionVisualMediaVariant;
(function (HeroSectionVisualMediaVariant) {
    HeroSectionVisualMediaVariant["image"] = "image";
    HeroSectionVisualMediaVariant["video"] = "video";
    HeroSectionVisualMediaVariant["videoBackground"] = "videoBackground";
})(HeroSectionVisualMediaVariant || (HeroSectionVisualMediaVariant = {}));
export var HeroSectionVisualTheme;
(function (HeroSectionVisualTheme) {
    HeroSectionVisualTheme["light"] = "light";
    HeroSectionVisualTheme["dark"] = "dark";
})(HeroSectionVisualTheme || (HeroSectionVisualTheme = {}));
const HeroSection = forwardRef(({ config, ...props }, ref) => {
    switch (config.type) {
        case HeroSectionVariant.visual:
            return React.createElement(HeroSectionVisual, { ...config, ...props, ref: ref });
        case HeroSectionVariant.textual:
            return React.createElement(HeroSectionTextual, { ...config, ...props, ref: ref });
        case HeroSectionVariant.split:
            return React.createElement(HeroSectionSplit, { ...config, ...props, ref: ref });
    }
});
HeroSection.displayName = 'HeroSection';
export default HeroSection;
